export const en = {
  'notices.title': 'Notifications',
  'notices.staffDescription': 'Shift swaps, leave decisions, bookings and reminders meant for you.',
  'notices.bell': 'Notifications',
  'notices.bellUnread': 'Notifications, {count} unread',
  'notices.unread': '{count} unread',
  'notices.markAllRead': 'Mark all read',
  'notices.allMarkedRead': 'All notifications marked as read',
  'notices.markRead': 'Mark as read',
  'notices.seeAll': 'See all notifications',
  'notices.showOlder': 'Show older',
  'notices.empty': 'You’re all caught up',
  'notices.emptyStaff': 'Shift swaps, leave decisions, bookings and reminders meant for you will appear here.',
  'notices.emptyMember': 'Booking confirmations, receipts and membership updates will appear here.',
  'notices.prefs.title': 'How you hear about notices',
  'notices.prefs.description': 'Kudos, awards, required reading and interviews always reach the bell. Choose whether they also reach you by email or text.',
  'notices.prefs.email': 'Email',
  'notices.prefs.emailHint': 'Sent to {email}.',
  'notices.prefs.sms': 'Text message',
  'notices.prefs.smsHint': 'Sent to the mobile number in your profile.',
  'notices.prefs.smsNoPhone': 'Add a mobile number to your profile first, or no text can reach you.',
  'notices.prefs.saved': 'Notification choices saved',
};

export const ka: Record<keyof typeof en, string> = {
  'notices.title': 'შეტყობინებები',
  'notices.staffDescription': 'თქვენთვის განკუთვნილი ცვლის გაცვლები, შვებულების გადაწყვეტილებები, ჯავშნები და შეხსენებები.',
  'notices.bell': 'შეტყობინებები',
  'notices.bellUnread': 'შეტყობინებები, {count} წაუკითხავი',
  'notices.unread': '{count} წაუკითხავი',
  'notices.markAllRead': 'ყველას წაკითხულად მონიშვნა',
  'notices.allMarkedRead': 'ყველა შეტყობინება წაკითხულად მოინიშნა',
  'notices.markRead': 'წაკითხულად მონიშვნა',
  'notices.seeAll': 'ყველა შეტყობინების ნახვა',
  'notices.showOlder': 'ძველების ჩვენება',
  'notices.empty': 'ახალი შეტყობინება არ გაქვთ',
  'notices.emptyStaff': 'აქ გამოჩნდება თქვენთვის განკუთვნილი ცვლის გაცვლები, შვებულების გადაწყვეტილებები, ჯავშნები და შეხსენებები.',
  'notices.emptyMember': 'აქ გამოჩნდება ჯავშნების დადასტურებები, ქვითრები და აბონემენტის სიახლეები.',
  'notices.prefs.title': 'როგორ იღებთ შეტყობინებებს',
  'notices.prefs.description': 'მადლობები, ჯილდოები, სავალდებულო საკითხავი და გასაუბრებები ყოველთვის ჩანს ზარზე. აირჩიეთ, მოგივიდეთ თუ არა ისინი ელფოსტითა და SMS-ითაც.',
  'notices.prefs.email': 'ელფოსტა',
  'notices.prefs.emailHint': 'იგზავნება მისამართზე {email}.',
  'notices.prefs.sms': 'SMS შეტყობინება',
  'notices.prefs.smsHint': 'იგზავნება თქვენს პროფილში მითითებულ მობილურზე.',
  'notices.prefs.smsNoPhone': 'SMS-ის მისაღებად ჯერ პროფილში მიუთითეთ მობილურის ნომერი.',
  'notices.prefs.saved': 'შეტყობინებების არჩევანი შენახულია',
};
